import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { ActivityDashboard } from '@/components/admin/ActivityDashboard';

export const Route = createFileRoute('/admin/activity')({
  component: AdminActivityPage,
});

function AdminActivityPage(): React.JSX.Element {
  return (
    <AdminLayout>
      <ActivityDashboard />
    </AdminLayout>
  );
}
